import { Component, OnDestroy, OnInit } from '@angular/core';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { Subject } from 'rxjs/Subject';
import { MessageService } from '@services/helpers/message-service/message.service';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';

@Component({
	selector: 'job-files-modal',
	template: require('./job-files-modal.component.html')
})
export class JobFilesModalComponent implements OnInit, OnDestroy {
	unsubscribe: Subject<void> = new Subject<void>();

	files: any;
	checkedFiles: any = {};
	maxMb: number;
	maxSize: number;

	constructor(
		private filesDataService: FileUploadDataProvider,
		private filesService: FileUploadServiceProvider,
		private messageService: MessageService
	) {
		this.maxSize = this.filesService.maxSize;
		this.maxMb = this.filesService.maxAttachment;
	}

	addAttachment() {
		this.checkedFiles = this.files.filter(file => file.checked);

		if (this.checkedFiles && this.checkedFiles.length) {
			const size = this.filesService.getTotalSize(this.checkedFiles);

			if (size > this.maxMb) {
				this.messageService.showToaster('w_0', 'attachments');
				return;
			}
		}

		this.filesDataService.setCheckedFiles(this.checkedFiles);
		this.dismiss();
		this.files = this.files.map(file => (file.checked = ''));
	}

	dismiss() {}

	ngOnInit() {
		this.filesDataService.filesObservable
			.takeUntil(this.unsubscribe)
			.subscribe(value => {
				this.files = [...value];
			});
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/common/sn-tiny-editor/job-files-modal/job-files-modal.component.ts